/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}h2[_ngcontent-%COMP%]{margin-top:0;margin-bottom:10px}ul[_ngcontent-%COMP%]{margin-bottom:0}.date[_ngcontent-%COMP%]{font-size:14px;color:#656565}.wrapper[_ngcontent-%COMP%]{margin:0 auto;padding:20px;max-width:900px}.change[_ngcontent-%COMP%]{padding:20px;border-radius:10px;background:#fff;margin-top:30px;box-shadow:0 0 3px 1px #00000040}@media screen and (max-width:500px){.change[_ngcontent-%COMP%]{margin-left:-20px;margin-right:-20px;border-radius:0}}"];
export { styles as styles };
